export interface ForgotPasswordDto {
  email: string,
}

export const forgotPasswordInit: ForgotPasswordDto = { email: '' };